import * as React from 'react';
import handleError from '@fuse/core/errorHandler';
import jwtService from './services/jwtService';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { logoutUser, setIsGreetingsVisible, setUser } from 'app/store/userSlice';
import { API } from 'app/configs/api';
import { HttpTransportType, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import {
  addMessage,
  deleteMessage,
  editMessage,
  updateMessagesStatuses,
} from 'app/theme-layouts/shared-components/chatPanel/store/chatSlice';
import { setOnlineUsers } from 'app/theme-layouts/shared-components/chatPanel/store/contactsSlice';
import {
  addLastMessage,
  addUnreadMessage,
  editLastMessage,
  getChatsIfNotExist,
  initializeChat,
  removeGroup,
  removeMemberFromGroup,
  substractUnreadMessage,
} from 'app/theme-layouts/shared-components/chatPanel/store/chatsSlice';
import {
  getConferenceAlarmsList,
  getNewAlarmsCount,
  selectConferenceAlarms,
  selectNewAlarmsCount,
  setVideoCallInfo,
} from 'app/store/alarmsSlice';
import { changeLanguageAsync } from 'app/store/i18nSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { setTheme } from 'app/store/themeSlice';
import { getStaffList, selectAllStaff } from 'app/store/staffSlice';
import { useUser } from '../hooks/useUser';
import { updateNavigationItem } from 'app/store/fuse/navigationSlice';
import { useTranslation } from 'react-i18next';
import { decrementCount, setCount } from 'app/store/applicationSlice';
import { fetchPermissions } from 'app/store/permissionThunk';
import JwtService from './services/jwtService';
import { setSignature } from 'app/store/deadlineDocumentSlice';

const AuthContext = React.createContext();

let refetchCallback;

export function registerRefetchHandler(callback) {
  refetchCallback = callback;
}
function AuthProvider({ children }) {
  const { t } = useTranslation('translations');
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);

  // const [signatureStatus, setSignatureStatus] = useState('pending');

  const dispatch = useDispatch();
  const staffList = useSelector(selectAllStaff);
  const { user } = useUser();
  const newAlarmsCount = useSelector(selectNewAlarmsCount);
  const count = useSelector((state) => state.applicationSlice.count);
  const { signatureAllDocument } = useSelector((state) => state.deadlineDocumentSlice);
  const { countDocument } = useSelector((state) => state.localNormativeActsSlice);

  useEffect(() => {
    if (user?.id) {
      dispatch(fetchPermissions(user));
    }
  }, [dispatch, user?.id]);

  const fetDeadLineData = async () => {
    try {
      const response = await axios.get(`${API.deadlineDocument}`, {
        headers: {
          Authorization: `Bearer ${jwtService.getAccessToken()}`,
        },
      });
      if (response?.data?.data?.length) {
        dispatch(setSignature(true));
      } else {
        dispatch(setSignature(false));
      }
    } catch (error) {
      dispatch(setSignature(false));
    }
  };

  useEffect(() => {
    if (user.staffId && user.staffId > 0) {
      fetDeadLineData();
    }
  }, [user.id]);

  useEffect(() => {
    if (signatureAllDocument) {
      const currentPath = window.location.pathname;

      if (signatureAllDocument && currentPath !== '/mandatory-document') {
        window.location.replace('/mandatory-document');
      } else if (!signatureAllDocument && currentPath !== '/') {
        window.location.replace('/');
      }
    }
  }, [fetDeadLineData]);

  // const currentDocumentId = 1;

  // useEffect(() => {
  //   if (!window.connection) return;

  //   const handleSignatureCompleted = (data) => {
  //     if (data.documentId === currentDocumentId) {
  //       setSignatureStatus('completed');
  //       dispatch(
  //         showMessage({
  //           message: t('DocumentHasBeenSigned'),
  //           variant: 'success',
  //         })
  //       );
  //     }
  //   };

  //   window.connection.on('documentSigned', handleSignatureCompleted);

  //   return () => {
  //     window.connection.off('documentSigned', handleSignatureCompleted);
  //   };
  // }, [currentDocumentId, dispatch, t]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getConferenceAlarmsList()).then((res) => {
        if (
          res.payload.items?.length &&
          window.location.pathname !== '/apps/video-conferences' &&
          newAlarmsCount !== 0
        ) {
          dispatch(updateNavigationItem('apps.video-conferences', { badge: { title: '' } }));
        } else if (res.payload.items?.length == 0) {
          dispatch(updateNavigationItem('apps.video-conferences', { badge: null }));
        }
      });
    }
  }, [newAlarmsCount, isAuthenticated]);

  useEffect(() => {
    dispatch(
      updateNavigationItem('apps.incoming-document', {
        badge: count ? { title: count } : null,
      })
    );
  }, [count]);

  const fetchInitialCount = async () => {
    try {
      const res = await axios.get(API.getCount, {
        headers: {
          Authorization: `Bearer ${jwtService.getAccessToken()}`,
        },
      });
      const count = res.data?.count ?? null;
      dispatch(setCount(count));
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    fetchInitialCount();
  }, []);

  useEffect(() => {
    async function success(user, message) {
      if (!user.roles || user.roles.length === 0) {
        dispatch(
          showMessage({
            message: 'Недостаточно полномочий. Обратитесь к администратору',
            variant: 'error',
          })
        );
        const language = localStorage.getItem('language');
        const isDarkMode = localStorage.getItem('isDarkMode');
        localStorage.clear();
        localStorage.setItem('language', language);
        localStorage.setItem('isDarkMode', isDarkMode);
        return;
      }
      Promise.all([
        dispatch(setUser(user)),
        dispatch(getStaffList()),
        // You can receive data here before app initialization
      ]).then((values) => {
        setWaitAuthCheck(false);
        setIsAuthenticated(true);
        if (
          moment(user?.profileCreatedDate).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') &&
          localStorage.getItem('isFirstTime') != 'false'
        ) {
          dispatch(setIsGreetingsVisible(true));
        }
      });
    }

    function pass(message) {
      if (message) {
        dispatch(showMessage({ message }));
      }

      setWaitAuthCheck(false);
      setIsAuthenticated(false);
    }

    const setUserLanguage = async (user) => {
      const langs = ['uz', 'ru'];
      const storageLanguage = langs.includes(localStorage.getItem('language'))
        ? localStorage.getItem('language')
        : 'uz';
      if (langs[user.localization] === storageLanguage) {
        return;
      } else if (!langs.includes[storageLanguage]) {
        //Language changed. Need to update language on server
        await dispatch(
          changeLanguageAsync({
            userId: user.id,
            lng: { code: langs.indexOf(storageLanguage), id: storageLanguage },
          })
        );
        // await jwtService.refreshToken();
      } else {
        //bad language detected
        localStorage.setItem('language', 'uz');
      }
    };

    const setUserTheme = async (user) => {
      const themes = ['false', 'true'];
      let storageIsDarkTheme = localStorage.getItem('isDarkMode');
      if (themes[user.theme] === storageIsDarkTheme) {
        return;
      } else if (themes.includes(storageIsDarkTheme)) {
        dispatch(setTheme(user.theme === 1));
        localStorage.setItem('isDarkMode', themes[user.theme]);
      } else {
        localStorage.setItem('isDarkMode', false);
        dispatch(setTheme(false));
      }
    };

    jwtService.on('onAutoLogin', () => {
      // dispatch(showMessage({ message: 'Signing in with JWT' }));

      /**
       * Sign in and retrieve user data with stored token
       */
      jwtService
        .signInWithToken()
        .then((user) => {
          success(user, 'Welcome');
          setUserLanguage(user);
          setUserTheme(user);
        })
        .catch((error) => {
          pass(error.message);
        });
    });

    jwtService.on('onLogin', (user) => {
      success(user, 'Signed in');
    });

    jwtService.on('onLogout', () => {
      pass('Signed out');

      dispatch(logoutUser());
      const isDarkMode = localStorage.getItem('isDarkMode') === 'true';
      dispatch(setTheme(isDarkMode));
    });

    jwtService.on('onAutoLogout', (message) => {
      pass(message);

      dispatch(logoutUser());
    });

    jwtService.on('onRefreshToken', (message) => {
      jwtService
        .refreshToken()
        .then((user) => {
          success(user, 'Login information updated');
        })
        .catch((error) => {
          pass(error.message);
        });
    });

    jwtService.on('onNoAccessToken', () => {
      pass();
    });

    jwtService.init();
  }, [dispatch]);

  useEffect(() => {
    if (!staffList || !staffList?.length) {
      return;
    }

    const showNotification = (message) => {
      if (Notification.permission === 'granted') {
        const foundEmployee = staffList.find(
          (empl) => empl.applicationUserId === message.userIdSender
        );
        const title = foundEmployee
          ? `${foundEmployee.fullName_Surname} ${foundEmployee.fullName_Name} ${foundEmployee.fullName_Patronymic}`
          : 'Новое сообщение';
        const notification = new Notification(title, {
          body: message.text,
          icon: 'assets/images/alarms/chatalarm.png',
        });
        notification.onclick = () => {
          window.open(`/apps/chat${message.chatGroupId ? '/' + message.chatGroupId : ''}`, '_self');
        };
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            showNotification(message);
          }
        });
      }
    };

    const showAlarmNotification = (message) => {
      if (Notification.permission === 'granted') {
        const notification = new Notification('Оповещение', {
          body: message.text,
          icon: 'assets/images/alarms/chatalarm.png',
        });
        notification.onclick = () => {
          window.open('', '_self');
        };
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            showAlarmNotification(message);
          }
        });
      }
    };

    const connect = async () => {
      try {
        const connection = new HubConnectionBuilder()
          .withUrl(process.env.REACT_APP_BASE_SOCKET_URL, {
            accessTokenFactory: () => jwtService.getAccessToken(),
            transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
          })
          .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: (retryContext) => {
              if (retryContext.elapsedMilliseconds < 10000) {
                // If we've been reconnecting for less than 10 seconds so far,
                // wait 2 seconds before the next reconnect attempt.
                return 2000;
              } else if (retryContext.elapsedMilliseconds < 120000) {
                // If we've been reconnecting for less than 120 seconds so far,
                // wait 10 seconds before the next reconnect attempt.
                return 10000;
              } else {
                // If we've been reconnecting more than 120 seconds ago,
                // wait 60 seconds before the next reconnect attempt.
                return 60000;
              }
            },
          })
          .configureLogging(LogLevel.Error)
          .build();

        connection.on('ReceiveMessage', (username, message) => {
          dispatch(addMessage(message));
          dispatch(addLastMessage(message));
        });

        connection.on('MessageRemoved', (message) => {
          dispatch(deleteMessage(message));
          dispatch(
            substractUnreadMessage({
              chatGroupId: message.chatId,
            })
          );
          dispatch(
            addLastMessage({
              id: message.lastMessageId,
              chatGroupId: message.chatId,
              text: message.lastMessage,
              createdDate: message.createdDate,
            })
          );
        });
        connection.on('MessageEdited', (message) => {
          dispatch(editMessage(message));
          dispatch(
            editLastMessage({
              id: message.messageId,
              chatGroupId: message.chatId,
              text: message.newText,
              createdDate: message.createdDate,
            })
          );
        });

        connection.on('ChatDeleted', (chat) => {
          dispatch(removeGroup(chat));
        });

        connection.on('UserLeftChat', (chat) => {
          dispatch(removeMemberFromGroup(chat));
        });

        connection.on('ReceiveMessageOffLine', (message) => {
          showNotification(message);
          dispatch(addUnreadMessage(message));
          dispatch(addLastMessage(message));
          dispatch(getChatsIfNotExist(message));
        });

        connection.on('ReceiveMessageStatus', (message) => {
          dispatch(updateMessagesStatuses(message));
        });

        connection.on('UpdateMessageStatus', (message) => {
          dispatch(updateMessagesStatuses(message));
        });

        connection.on('GetOnlineUsers', (users) => {
          dispatch(setOnlineUsers(users));
          setTimeout(() => dispatch(initializeChat()), 500);
        });

        connection.on('send', (data) => {
          // console.log(data);
        });

        connection.on('connect', () => {
          console.log('chathub connected');
        });

        connection.onreconnected(() => {
          console.log('Chat reconnected: ' + moment().format('DD.MM.YYYY HH:mm:ss'));
          setTimeout(() => {
            const unsentMessages = JSON.parse(localStorage.getItem('unsentMessages'));
            if (Array.isArray(unsentMessages) && unsentMessages.length > 0) {
              unsentMessages.reverse().forEach((message) => {
                window.connection?.invoke('SendGroupMessage', message);
              });
            }
            localStorage.removeItem('unsentMessages');
          }, [1000]);

          connection?.invoke('EnterChat', undefined, null);
        });

        await connection.start();
        window.connection = connection;
      } catch (e) {
        console.log('Connection error!', e.message);
      }
    };

    const connectAlarmWS = async () => {
      try {
        const alarmsConnection = new HubConnectionBuilder()
          .withUrl(process.env.REACT_APP_ALARMS_SOCKET_URL, {
            accessTokenFactory: () => jwtService.getAccessToken(),
          })
          .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: (retryContext) => {
              if (retryContext.elapsedMilliseconds < 120000) {
                // If we've been reconnecting for less than 120 seconds so far,
                // wait 10 seconds before the next reconnect attempt.
                return 10000;
              } else {
                // If we've been reconnecting more than 120 seconds ago,
                // wait 60 seconds before the next reconnect attempt.
                return 60000;
              }
            },
          })
          .configureLogging(LogLevel.Error)
          .build();

        alarmsConnection.on('connect', () => {
          console.log('alarmhub connected');
        });

        alarmsConnection.on('Logout', () => {
          JwtService.logout();
          window.location.reload();
        });

        alarmsConnection.on('AwaitingApplicationCount', (data) => {
          if (data?.applicationCount !== undefined) {
            dispatch(setCount(data.applicationCount));
          } else {
            dispatch(decrementCount());
          }

          if (refetchCallback) {
            refetchCallback();
          }
        });

        alarmsConnection.on('ReceiveMessage', (message) => {
          dispatch(getNewAlarmsCount());
          showAlarmNotification(message);
          if (message.senderSystemId === 5) {
            dispatch(setVideoCallInfo(message));
            dispatch(getConferenceAlarmsList());
            if (window.location.pathname !== '/apps/video-conferences') {
              dispatch(
                updateNavigationItem('apps.video-conferences', {
                  badge: {
                    title: '',
                  },
                })
              );
            }
          }
        });

        await alarmsConnection.start();
        window.alarmsConnection = alarmsConnection;
      } catch (e) {
        console.log('alarmsConnection error!', e.message);
      }
    };

    if (user?.staffId) {
      connect();
      connectAlarmWS();
    }
  }, [staffList, user]);

  return waitAuthCheck ? (
    <FuseSplashScreen />
  ) : (
    <AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
